require('./mortgageRequestHolderInformation.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const moment = require('moment');
const { contains } = require('lodash');

// @utilities
const { recordProcess, PROC_START, PROC_CANCEL } = require('utilities/tagging');
const { getTextDescription, getTextLinkDescription } = require('utilities/dragNDropUpload');

// @track processes
const { PROC_CHANGE_HOLDER_DATA } = require('constants/mortgageRequestProcesses');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { InputSafe } = require('commonsComponents/inputSafe');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKModal = require('components/commons/OKModal/OKModal');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');
const MortgageRequestGoToDocCenter = require('../mortgageRequestGoToDocCenter/mortgageRequestGoToDocCenter');
const Message = require('../mortgageRequestPanel/mortgageRequestDataProprietor/message');

// @actions
const getHolderActions = require('actions/mortgageRequest/mortgageRequestHolder');
const getLocationData = require('actions/mortgageRequest/mortgageRequestLocationData');
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');

// @constants
const { typesOfRoadsOptions } = require('constants/typeOfRoads');
const FILE_MAX_SIZE = 5120;
const { DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES, DRAG_N_DROP_UPLOAD_ERROR_MESSAGE } = require('constants/commonsComponents');
const texts = {
    actualFile: <FormattedText value={`dragNDropUpload-actualFile`} />,
    selectedFile: <FormattedText value={`dragNDropUpload-selectedFile`} />,
    sizeError: <FormattedText value={`dragNDropUpload-sizeError`} injectedStrings={[FILE_MAX_SIZE]} />,
    typeError: <FormattedText value="dragNDropUpload-typeError" injectedStrings={[DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES.join(', ')]} />,
}
const mortgageRequestPanelStates = require('constants/mortgageRequestPanelStates');
const { COMMONS: { PRESTAMOS_PHONE }, DOCUMENTS_STATUS, getCivilStatusOptions, getIdNumberOptions } = require('constants/mortgageRequestHolderData');
const { countryOptions } = require('constants/countries');
const { DNI_FRONT, DNI_BACK } = require('constants/mortgageRequestDocumentsTypes');
const { HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER } = require('constants/flagBasedFeatures');

// Constants for errors when validate a form
const { COMMONS } = require('constants/mortgageRequestHolderData');

class MortgageRequestHolderInformation extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            ordenNm: '',
            ordenNmValid: false,
            name: '',
            nameValid: false,
            lastname1: '',
            lastname1Valid: false,
            lastname2: '',
            lastname2Valid: false,
            nationality: '',
            nationalityValid: false,
            day: '',
            dayValid: false,
            month: '',
            monthValid: false,
            year: '',
            yearValid: false,
            civilStatus: '',
            civilStatusValid: false,
            personsNumber: '',
            personsNumberValid: {},
            idDocument: '',
            idDocumentValid: false,
            idDocumentText: '',
            idDocumentTextValid: false,
            expirationDay: '',
            expirationDayValid: false,
            expirationMonth: '',
            expirationMonthValid: false,
            expirationYear: '',
            expirationYearValid: false,
            placeResidence: '',
            placeResidenceValid: false,
            location: '',
            locationValid: false,
            province: '',
            provinceValid: false,
            postalCode: '',
            postalCodeValid: false,
            typeOfRoad: '',
            typeOfRoadValid: false,
            nameOfRoad: '',
            nameOfRoadValid: false,
            numberOfRoad: '',
            numberOfRoadValid: false,
            confirm: false,
            confirmValid: false,
            mailAdicional: '',
            mailAdicionalValid: false,
            openbankFl: '',
            openbankFlValid: false,
            persdeclfl: '',
            isFetching: false,
            isExpanded: false,
            fileDNIFRONTValid: false,
            fileDNIFRONTErrorMessage: DRAG_N_DROP_UPLOAD_ERROR_MESSAGE,
            fileDNIBACKValid: false,
            fileDNIBACKErrorMessage: DRAG_N_DROP_UPLOAD_ERROR_MESSAGE,
            filesValid: true,
            isOpenbankClient: !props.isClientWithoutAccounts,
            isDisabledButton: false,
            isCompleted: false,
        };

        this.state = this.initialState;
        this.files = [];
        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleToggleErrorModal = this.handleToggleErrorModal.bind(this);
        this.handleSelectCivilStatus = this.handleSelectCivilStatus.bind(this);
        this.handleSelectIdDocument = this.handleSelectIdDocument.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.updateLocalState = this.updateLocalState.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.validateDate = this.validateDate.bind(this);
        this.validateExpirationDate = this.validateExpirationDate.bind(this);
        this.handleSelectProvince = this.handleSelectProvince.bind(this);
        this.handleSelectLocation = this.handleSelectLocation.bind(this);
        this.handleSelectNacionality = this.handleSelectNacionality.bind(this);
        this.handleCancelAddCoHolder = this.handleCancelAddCoHolder.bind(this);
        this.handleOnChangeFile = this.handleOnChangeFile.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.validateStepCompleted = this.validateStepCompleted.bind(this);
        this.handleSelectTypeOfRoad = this.handleSelectTypeOfRoad.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { immMortgageRequestState, holderInfo, requestHolder, holderId, requestProvincesData } = this.props;
        const stateIsLoading = immMortgageRequestState.get('isFetching');
        const holderIsLoading = holderInfo.get('isFetching');

        requestProvincesData();

        if (
            !stateIsLoading &&
            !holderIsLoading &&
            (!holderInfo.get('requestedId') || holderId != holderInfo.get('requestedId'))
        ) {
            requestHolder(holderId);
        } else if (holderInfo.get('flag')) {
            requestHolder(holderId);
        }
    }

    componentDidMount() {
        recordProcess(PROC_CHANGE_HOLDER_DATA, PROC_START);
        this.validateStepCompleted();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const stateIsLoading = nextProps.immMortgageRequestState.get('isFetching');
        const holderIsLoading = nextProps.holderInfo.get('isFetching');
        if (
            nextProps.holderInfo.get('ordenNm') &&
            this.state.ordenNm !== nextProps.holderInfo.get('ordenNm') &&
            nextProps.holderId === nextProps.holderInfo.get('requestedId') &&
            !stateIsLoading &&
            !holderIsLoading
        ) {
            this.updateLocalState(nextProps.holderInfo);
        } else if (
            nextProps.holderInfo.get('idDocumentText') !== this.state.idDocumentText &&
            nextProps.holderId === nextProps.holderInfo.get('requestedId') &&
            !stateIsLoading &&
            !holderIsLoading
        ) {
            this.updateLocalState(nextProps.holderInfo);
        }
        if (
            !stateIsLoading &&
            !holderIsLoading &&
            (!nextProps.holderInfo.get('requestedId') ||
                nextProps.holderId != nextProps.holderInfo.get('requestedId'))
        ) {
            this.props.resetPersonalDataState();
            this.setState(this.initialState);
            nextProps.requestHolder(nextProps.holderId);
        }

        if (nextProps.immMortgageRequestLocationData.getIn(['populationData', 'populationsList'])) {
            this.locations = nextProps.immMortgageRequestLocationData.getIn(['populationData', 'populationsList']).toJS().map(data => ({ label: data.name, value: data.id }));
            const location = this.locations.find(location => location.label === this.state.location || location.label === this.state.location.label);

            if (!!location) {
                this.setState({
                    location
                });
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { holdersDataValidation } = this.props;
        if (holdersDataValidation !== prevProps.holdersDataValidation) {
            this.validateStepCompleted();
        }
    }

    componentWillUnmount() {
        this.props.resetPersonalDataState();
    }

    validateStepCompleted() {
        const { holdersDataValidation, isHolder } = this.props;
        const holderKey = isHolder ? 'isHolder' : 'isCoHolder';
        const { stepsValidation, isCompleted } = holdersDataValidation.get(holderKey).toJS();
        this.setState({ isCompleted });
        const event = {
            target: {
                id: 'confirm',
                checked: stepsValidation[0],
            }
        }
        this.handleCheckboxChange(event);
    }

    handleBlur(evt) {
        const field = evt.target;
        const value = field.value.trim();
        this.setState({ [field.name]: value });
    }

    handleCancelAddCoHolder(evt) {
        evt.preventDefault();
        recordProcess(PROC_CHANGE_HOLDER_DATA, PROC_CANCEL);
        this.props.history.push('/myprofile/mortgage/panel');
    }

    handleChange(evt) {
        const { name, value } = evt.target;
        let nonNumericRegex = /[^0-9]+/g;
        this.setState(() => {
            switch (name) {
                case 'name':
                case 'lastname1':
                case 'lastname2':
                    if (this.isValidName(value) || value === '') {
                        return { [name]: value };
                    }
                    break;
                case 'day':
                case 'expirationDay':
                    return { [name]: value.replace(nonNumericRegex, '').trim() };
                case 'month':
                case 'expirationMonth':
                    return { [name]: value.replace(nonNumericRegex, '').trim() };
                case 'year':
                case 'expirationYear':
                    return { [name]: value.replace(nonNumericRegex, '').trim() };
                case 'personsNumber':
                    return {
                        [name]: value.replace(nonNumericRegex, '').trim(),
                        personsNumberValid: this.validateDependents(value.replace(nonNumericRegex, '').trim())
                    };
                case 'phoneNumber':
                    nonNumericRegex = /^[^67]|[^\d]+/g;
                    return { [name]: value.replace(nonNumericRegex, '').trim() };
                case 'postalCode':
                case 'numberStreet':
                case 'numberOfRoad':
                    return { [name]: value.replace(nonNumericRegex, '').trim() };
                default:
                    return { [name]: value };
            }
        }, () => this.setEnabledButton());
    }

    handleCheckboxChange(event) {
        this.setState({
            [event.target.id]: event.target.checked
        }, () => this.setEnabledButton());
    }

    setEnabledButton() {
        const { immFlagBasedFeatures } = this.props;

        if (immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER)) {
            const valid = this.validateFields();
            this.setState({ isDisabledButton: !valid });
        }
    }

    handleSave(event) {
        event && event.preventDefault();
        const { isHolder, handleEditHolder, handleEditCoHolder, immMortgageRequestState, isClientWithoutAccounts, uploadFiles, history } = this.props;

        const valid = this.validateFields();
        const currentRecord = immMortgageRequestState.get('idExpediente');

        if (valid) {
            if (isHolder) {
                if (isClientWithoutAccounts) {
                    uploadFiles(currentRecord, this.state, history);
                } else {
                    handleEditHolder(currentRecord, this.state, history);
                }
            } else {
                handleEditCoHolder(currentRecord, this.state, history);
            }
        }
    }

    handleOnChangeFile(fileId, fileState) {
        if (fileState && !fileState.error) {
            this.props.addFile({
                fileId,
                file: fileState.file
            });
        }
    }
    handleSelectCivilStatus(value) {
        this.setState({
            civilStatus: value ? value.value === 'NO_CONSTA' ? '' : value.value : ''
        }, () => this.setEnabledButton());
    }

    handleSelectNacionality(value) {
        this.setState({
            nationality: value ? value.value : ''
        }, () => this.setEnabledButton())
    }

    handleSelectIdDocument(value) {
        this.setState({
            idDocument: value.value
        }, () => this.setEnabledButton());
    }

    handleSelectTypeOfRoad(value) {
        this.setState({
            typeOfRoad: value ? value.value : ''
        }, () => this.setEnabledButton());
    }

    handleSelectProvince(value) {
        this.setState({
            province: value ? value : '',
            location: ''
        }, () => {
            if (this.state.province) {
                this.props.requestLocationData(this.state.province.value)
            }
            this.setEnabledButton();
        });
    }

    handleSelectLocation(value) {
        this.setState({
            location: value ? value : ''
        }, () => this.setEnabledButton());
    }

    handleToggleErrorModal(evt) {
        evt.preventDefault();
        this.setState({
            showErrorModal: !this.state.showErrorModal
        });
        this.props.resetCoHolderDataState();
    }

    updateLocalState(holderInfo) {
        const { orderNm, requestLocationData, immMortgageRequestLocationData, requestSummaryDocumentation, immGlobalPosition } = this.props;
        this.setState({
            ordenNm: orderNm ? orderNm : holderInfo.get('ordenNm'),
            ordenNmValid: false,
            name: holderInfo.get('name'),
            nameValid: false,
            lastname1: holderInfo.get('lastname1'),
            lastname1Valid: false,
            lastname2: holderInfo.get('lastname2'),
            lastname2Valid: false,
            nationality: holderInfo.get('nationality').length > 3 ? 'ES' : holderInfo.get('nationality'),
            nationalityValid: false,
            day: holderInfo.get('day'),
            dayValid: false,
            month: holderInfo.get('month'),
            monthValid: false,
            year: holderInfo.get('year'),
            yearValid: false,
            civilStatus: holderInfo.get('civilStatus') == 'NO_CONSTA' ? '' : holderInfo.get('civilStatus'),
            civilStatusValid: false,
            personsNumber: holderInfo.get('personsNumber'),
            personsNumberValid: this.validateDependents(holderInfo.get('personsNumber')),
            idDocument: holderInfo.get('idDocument'),
            idDocumentValid: false,
            idDocumentText: holderInfo.get('idDocumentText'),
            idDocumentTextValid: false,
            expirationDay: holderInfo.get('expirationDay'),
            expirationDayValid: false,
            expirationMonth: holderInfo.get('expirationMonth'),
            expirationMonthValid: false,
            expirationYear: holderInfo.get('expirationYear'),
            expirationYearValid: false,
            placeResidence: holderInfo.get('placeResidence'),
            placeResidenceValid: false,
            location: holderInfo.get('location'),
            locationValid: false,
            provinceCode: holderInfo.get('provinceCode'),
            province: holderInfo.get('province'),
            provinceValid: false,
            postalCode: holderInfo.get('postalCode'),
            postalCodeValid: false,
            typeOfRoad: holderInfo.get('typeOfRoad'),
            typeOfRoadValid: false,
            nameOfRoad: holderInfo.get('nameOfRoad'),
            nameOfRoadValid: false,
            numberOfRoad: holderInfo.get('numberOfRoad'),
            numberOfRoadValid: false,
            confirmValid: false,
            mailAdicional: holderInfo.get('mailAdicional'),
            mailAdicionalValid: false,
            openbankFl: holderInfo.get('openbankFl'),
            openbankFlValid: false,
            persdeclfl: '',
            isOpenbankClient: !immGlobalPosition.get("isClientWithoutAccounts") || holderInfo.get('isOpenbankClient')
        }, () => {
            this.provinces = immMortgageRequestLocationData.get('provincesList').toJS().map(data => ({ label: data.name, value: data.id }));
            const province = this.provinces.find(province => province.value === Number(this.state.provinceCode) || province.label === this.state.province);

            if (!!province) {
                this.setState({
                    province
                }, () => {
                    requestLocationData(this.state.province.value, undefined, undefined, false, false, true);
                });
            } else {
                this.setState({
                    province: '',
                    location: ''
                })
            }

            if (!this.state.isOpenbankClient) {
                requestSummaryDocumentation(undefined, this.state.idDocumentText, this.state.idDocument);
            }
            this.setEnabledButton();
        });
    }

    isValidName(value) {
        const REGEX_NAME = /^(?:(?=[^\^_\]\[])[A-záéíóúÁÉÍÓÚñÑ\s])+$/;
        return REGEX_NAME.test(value);
    }

    validateDate(day, month, year, expirationDate) {
        const addDefaultError = formatText('mortgageRequestHolderInformation-defaultFormError');
        const dayInvalidMsg = formatText('mortgageRequestHolderInformation-dayInvalid');
        const monthInValidMsg = formatText('mortgageRequestHolderInformation-monthInvalid');
        const yearInvalidMsg = formatText('mortgageRequestHolderInformation-yearInvalid');

        const dia = this.state[day];
        const mes = this.state[month];
        const anio = this.state[year];
        let valid = true;

        this.setState({
            [`${day}Valid`]: false,
            [`${month}Valid`]: false,
            [`${year}Valid`]: false
        });

        if (dia === '') {
            this.setState({
                [`${day}Valid`]: true,
                [`${day}Error`]: addDefaultError
            });
            valid = false;
        }

        if (mes === '') {
            this.setState({
                [`${month}Valid`]: true,
                [`${month}Error`]: addDefaultError
            });
            valid = false;
        }

        if (anio === '') {
            this.setState({
                [`${year}Valid`]: true,
                [`${year}Error`]: addDefaultError
            });
            valid = false;
        }

        if (valid) {
            if (dia == 31 && (mes == 4 || mes == 6 || mes == 9 || mes == 11)) {
                this.setState({
                    [`${day}Valid`]: true,
                    [`${day}Error`]: dayInvalidMsg
                });
                valid = false;
            } else if (dia >= 30 && mes == 2) {
                this.setState({
                    [`${day}Valid`]: true,
                    [`${day}Error`]: dayInvalidMsg
                });
                valid = false;
            } else if (dia > 31 && dia <= 29) {
                this.setState({
                    [`${day}Valid`]: true,
                    [`${day}Error`]: dayInvalidMsg
                });
                valid = false;
            } else if (
                mes == 2 &&
                dia == 29 &&
                !(anio % 4 == 0 && (anio % 100 != 0 || anio % 400 == 0))
            ) {
                this.setState({
                    [`${year}Valid`]: true,
                    [`${year}Error`]: yearInvalidMsg
                });
                valid = false;
            }

            if (dia <= 0 || dia > 31) {
                this.setState({
                    [`${day}Valid`]: true,
                    [`${day}Error`]: dayInvalidMsg
                });
                valid = false;
            }

            if (anio <= 0) {
                this.setState({
                    [`${year}Valid`]: true,
                    [`${year}Error`]: yearInvalidMsg
                });
                valid = false;
            }

            if (mes <= 0 || mes > 12) {
                this.setState({
                    [`${month}Valid`]: true,
                    [`${month}Error`]: monthInValidMsg
                });
                valid = false;
            }

            if (expirationDate && valid) {
                valid = this.validateExpirationDate(dia, mes, anio);
            }

        }

        return valid;
    }

    isValidBirthDate(day, month, year) {
        const now = moment(new Date()).format('YYYY-MM-DD');
        const birthDate = moment([year, month - 1, day]).format('YYYY-MM-DD');

        return moment(now).diff(birthDate, 'years') >= 18;
    }

    validateExpirationDate(day, month, year) {
        const now = moment().format('YYYY-MM-DD');
        const expirationDate = moment([year, month - 1, day]).format('YYYY-MM-DD');
        const addExpirationDateError = formatText('mortgageRequestHolderInformation-expirationDateError');

        if (expirationDate <= now) {
            this.setState({ expirationDayValid: true, expirationDayError: addExpirationDateError });
            this.setState({ expirationMonthValid: true, expirationMonthError: '' });
            this.setState({ expirationYearValid: true, expirationYearError: '' });
            return false;
        } else {
            this.setState({ expirationDayValid: false });
            this.setState({ expirationMonthValid: false });
            this.setState({ expirationYearValid: false });
            return true;
        }
    }

    validateDependents(dependents = 0) {
        const dependentsClone = Number(dependents);
        const MIN_DEPENDENTS = 0;
        const MAX_DEPENDENTS = 20;
        const isDependentsValueValid = dependentsClone >= MIN_DEPENDENTS && dependentsClone <= MAX_DEPENDENTS;
        const errorMessage = formatText('mortgageRequestHolderInformation-mortgageRequestHolderInformation_dependentsErrorMessage');
        const isDependentsFieldEmpty = dependents === '';
        const addDefaultError = formatText('mortgageRequestHolderInformation-defaultFormError');

        let error = '';
        let valid = false;

        if (isDependentsFieldEmpty) {
            error = addDefaultError;
        } else if (!isDependentsValueValid) {
            error = errorMessage;
        } else {
            valid = true;
        }

        return { valid, error };
    }

    validateFields() {
        const { isHolder, holderEdit, immFlagBasedFeatures } = this.props;
        const { isOpenbankClient } = this.state;
        const addDefaultError = formatText('mortgageRequestHolderInformation-defaultFormError');
        const defaultInvalidError = formatText('mortgageRequestHolderInformation-invalidFormatError');
        const birthDateError = formatText('mortgageRequestHolderInformation-invalidBirthdateError');
        const fileRequiredError = formatText('mortgageRequestHolderInformation-fileRequiredError');
        const isShowDocumentUpload = !(immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER));

        //Form validations
        let valid = true;
        if (this.state.name === '') {
            this.setState({ nameValid: true, nameError: addDefaultError });
            valid = false;
        } else if (!this.isValidName(this.state.name)) {
            this.setState({ nameValid: true, nameError: defaultInvalidError });
            valid = false;
        } else {
            this.setState({ nameValid: false });
        }
        if (this.state.lastname1 === '') {
            this.setState({ lastname1Valid: true, lastname1Error: addDefaultError });
            valid = false;
        } else if (!this.isValidName(this.state.lastname1)) {
            this.setState({ lastname1Valid: true, lastname1Error: defaultInvalidError });
            valid = false;
        } else {
            this.setState({ lastname1Valid: false });
        }
        if (this.state.lastname2 === '') {
            this.setState({ lastname2Valid: true, lastname2Error: addDefaultError });
            valid = false;
        } else if (!this.isValidName(this.state.lastname2)) {
            this.setState({ lastname2Valid: true, lastname2Error: defaultInvalidError });
            valid = false;
        } else {
            this.setState({ lastname2Valid: false });
        }
        if (this.state.nationality === '' || this.state.nationality.length > 3) {
            this.setState({ nationalityValid: true });
            valid = false
        } else {
            this.setState({ nationalityValid: false });
        }
        if (this.state.expirationDay === '') {
            this.setState({ expirationDayValid: true, expirationDayError: addDefaultError });
            valid = false;
        } else if (!this.validateDate('expirationDay', 'expirationMonth', 'expirationYear', true)) {
            valid = false;
        } else {
            this.setState({ expirationDayValid: false });
        }
        if (!this.validateDate('day', 'month', 'year', false)) {
            valid = false;
        } else if (!this.isValidBirthDate(this.state.day, this.state.month, this.state.year)) {
            this.setState({ dayValid: true, dayError: birthDateError });
            this.setState({ monthValid: true });
            this.setState({ yearValid: true });
            valid = false;
        } else {
            this.setState({ dayValid: false });
            this.setState({ monthValid: false });
            this.setState({ yearValid: false });
        }
        if (this.state.civilStatus === '') {
            this.setState({ civilStatusValid: true });
            valid = false;
        } else {
            this.setState({ civilStatusValid: false });
        }
        const dependentsValidationObject = this.validateDependents(this.state.personsNumber);
        this.setState({
            personsNumberValid: dependentsValidationObject
        });
        if (!dependentsValidationObject.valid) {
            valid = false;
        }
        if (!isOpenbankClient) {
            if (this.state.typeOfRoad === '') {
                this.setState({ typeOfRoadValid: true });
                valid = false;
            } else {
                this.setState({ typeOfRoadValid: false });
            }
            if (this.state.nameOfRoad === '') {
                this.setState({ nameOfRoadValid: true });
                valid = false;
            } else {
                this.setState({ nameOfRoadValid: false });
            }
            if (this.state.numberOfRoad === '') {
                this.setState({ numberOfRoadValid: true });
                valid = false;
            } else {
                this.setState({ numberOfRoadValid: false });
            }
            if (this.state.postalCode === '') {
                this.setState({ postalCodeValid: true });
                valid = false;
            } else {
                this.setState({ postalCodeValid: false });
            }
            if (this.state.province === '') {
                this.setState({ provinceValid: true });
                valid = false;
            } else {
                this.setState({ provinceValid: false });
            }
            if (this.state.location === '') {
                this.setState({ locationValid: true });
                valid = false;
            } else {
                this.setState({ locationValid: false });
            }
            if (isHolder && isShowDocumentUpload) {
                if (holderEdit.get('files').size === 0 && !this.existsDNIFile(DNI_FRONT) && !this.existsDNIFile(DNI_BACK)) {
                    this.setState({
                        fileDNIFRONTValid: true,
                        fileDNIFRONTErrorMessage: fileRequiredError,
                        fileDNIBACKValid: true,
                        fileDNIBACKErrorMessage: fileRequiredError,
                        filesValid: false
                    });
                    valid = false;
                } else {
                    if (!holderEdit.getIn(['files', DNI_FRONT]) && !this.existsDNIFile(DNI_FRONT)) {
                        this.setState({
                            fileDNIFRONTValid: true,
                            fileDNIFRONTErrorMessage: fileRequiredError,
                            filesValid: false
                        });
                        valid = false;
                    } else {
                        this.setState({
                            fileDNIFRONTValid: false,
                            fileDNIFRONTErrorMessage: DRAG_N_DROP_UPLOAD_ERROR_MESSAGE
                        });
                    }
                    if (!holderEdit.getIn(['files', DNI_BACK]) && !this.existsDNIFile(DNI_BACK)) {
                        this.setState({
                            fileDNIBACKValid: true,
                            fileDNIBACKErrorMessage: fileRequiredError,
                            filesValid: false
                        });
                        valid = false;
                    } else {
                        this.setState({
                            fileDNIBACKValid: false,
                            fileDNIBACKErrorMessage: DRAG_N_DROP_UPLOAD_ERROR_MESSAGE
                        });
                    }
                }
            }
        }

        valid &= this.validateDate('expirationDay', 'expirationMonth', 'expirationYear', true);

        if (!this.state.confirm && !isHolder) {
            this.setState({ confirmValid: true });
            valid = false;
        } else {
            this.setState({ confirmValid: false });
        }
        return valid;
    }

    buildModal() {
        const { coHolderEdit } = this.props;
        const showModal = coHolderEdit.get('error') && !coHolderEdit.get('isFetching');

        return (
            <OKModal
                description={formatText('mortgageRequestHolderInformation-modalErrorMessage', [PRESTAMOS_PHONE])}
                footerType="action"
                isOpen={showModal}
                onCloseCallback={this.handleToggleErrorModal}
                onPrimaryButtonClick={this.handleToggleErrorModal}
                primaryButtonText="mortgageRequestHolderInformation-modalErrorButtonText"
                title="mortgageRequestHolderInformation-modalErrorTitle"
            />
        );
    }

    handleClick(isExpanded) {
        this.setState({ isExpanded });
    }

    existsDNIFile(type) {
        const { immSummaryDocumentation } = this.props;

        const file = immSummaryDocumentation.get('data').find(file => {
            const fileState = file.get('estado');
            return fileState !== DOCUMENTS_STATUS.NONE &&
                fileState !== DOCUMENTS_STATUS.EXENTO &&
                fileState !== DOCUMENTS_STATUS.PEND_APORTAR &&
                file.get('tipoDocumentoId') === type;
        });

        return file ? true : false;
    }

    handleOnDownloadFile(fileType) {
        this.props.requestDocument({
            documentType: fileType,
            idDocumentNumber: this.state.idDocumentText,
            idDocumentType: this.state.idDocument
        });
    }

    buildDNIUploadContent(isApprovedDataProprietor) {
        const { isOpenbankClient } = this.state;
        const { isHolder } = this.props;

        let content;

        if (!isOpenbankClient && isHolder) {
            const dniAccordionLabel = this.state.isExpanded ? 'mortgageRequestHolderInformation-DNIIntructionOpenTitle' : 'mortgageRequestHolderInformation-DNIIntructionCloseTitle';
            const existsFileDNI_FRONT = this.existsDNIFile(DNI_FRONT);
            const existsFileDNI_BACK = this.existsDNIFile(DNI_BACK);
            const DNIFrontCurrent = formatText('mortgageRequestHolderInformation-dniFront');
            const DNIBackCurrent = formatText('mortgageRequestHolderInformation-dniBack');
            const textDescription = getTextDescription();
            const textLinkDescription = getTextLinkDescription();

            content = (
                <div className="row mortgage-request-holder-information__margin">
                    <div className="col-xs-12">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="mortgage-request-holder-information__upload-dni">
                                    <FormattedText
                                        value="mortgageRequestHolderInformation-dniLabel"
                                        className="mortgage-request-holder-information__upload-dni-title"
                                    />
                                    <FormattedText value="mortgageRequestHolderInformation-attachDNI"
                                        className="mortgage-request-holder-information__upload-dni-subtitle"
                                    />
                                    <FormattedText
                                        value="mortgageRequestHolderInformation-dndDNIInstructions"
                                        className="mortgage-request-holder-information__upload-dni-information"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-8">
                                <Accordion customClassName="mortgage-request-holder-information__upload-dni-accordion" onClick={this.handleClick}>
                                    <AccordionHeader name="AccordionHeader" isRightArrowPosition>
                                        <FormattedText
                                            value={dniAccordionLabel}
                                            className="mortgage-request-holder-information__upload-dni-accordion-header--title"
                                        />
                                    </AccordionHeader>
                                    <AccordionBody name="AccordionBody">
                                        <div className="mortgage-request-holder-information__upload-dni-accordion-body">
                                            <div className="row">
                                                <div className="col-xs-4 mortgage-request-holder-information__upload-dni-accordion-body-item">
                                                    <i className="icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon-flat-surface" />
                                                    <FormattedText value="mortgageRequestHolderInformation-dniUploadIntruction1" />
                                                </div>
                                                <div className="col-xs-4 mortgage-request-holder-information__upload-dni-accordion-body-item mortgage-request-holder-information__upload-dni-accordion-body-item--border-left">
                                                    <i className="icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon-clear-image" />
                                                    <FormattedText value="mortgageRequestHolderInformation-dniUploadIntruction2" />
                                                </div>
                                                <div className="col-xs-4 mortgage-request-holder-information__upload-dni-accordion-body-item mortgage-request-holder-information__upload-dni-accordion-body-item--border-left">
                                                    <i className="icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon-natural-light" />
                                                    <FormattedText value="mortgageRequestHolderInformation-dniUploadIntruction3" />
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionBody>
                                </Accordion>
                            </div>
                        </div>
                        <div className="row mortgage-request-holder-information__margin">
                            <div className="col-xs-4">
                                <FormattedText
                                    value="mortgageRequestHolderInformation-dniFront"
                                    className="mortgage-request-holder-information__upload-dni-label mortgage-request-holder-information__upload-dni-label--bold"
                                />
                                <FormattedText
                                    value="mortgageRequestHolderInformation-dniDocumentType"
                                    className="mortgage-request-holder-information__upload-dni-label"
                                />
                                <div className="mortgage-request-holder-information__upload-dni-dnd">
                                    <DragNDropUpload
                                        idName="frontDNI"
                                        onChange={fileState => this.handleOnChangeFile(DNI_FRONT, fileState)}
                                        maxSize={FILE_MAX_SIZE}
                                        ammountFiles={Number(existsFileDNI_FRONT)}
                                        overwriteFile
                                        isModern
                                        texts={texts}
                                        error={this.state.fileDNIFRONTValid}
                                        errorMessage={this.state.fileDNIFRONTErrorMessage}
                                        fileText={DNIFrontCurrent}
                                        onDownload={() => this.handleOnDownloadFile(DNI_FRONT)}
                                        textDescription={textDescription}
                                        textLinkDescription={textLinkDescription}
                                        disabled={isApprovedDataProprietor}
                                    />
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <FormattedText
                                    value="mortgageRequestHolderInformation-dniBack"
                                    className="mortgage-request-holder-information__upload-dni-label mortgage-request-holder-information__upload-dni-label--bold"
                                />
                                <FormattedText
                                    value="mortgageRequestHolderInformation-dniDocumentType"
                                    className="mortgage-request-holder-information__upload-dni-label"
                                />
                                <div className="mortgage-request-holder-information__upload-dni-dnd">
                                    <DragNDropUpload
                                        idName="backDNI"
                                        onChange={fileState => this.handleOnChangeFile(DNI_BACK, fileState)}
                                        maxSize={FILE_MAX_SIZE}
                                        ammountFiles={Number(existsFileDNI_BACK)}
                                        overwriteFile
                                        isModern
                                        texts={texts}
                                        error={this.state.fileDNIBACKValid}
                                        errorMessage={this.state.fileDNIBACKErrorMessage}
                                        fileText={DNIBackCurrent}
                                        onDownload={() => this.handleOnDownloadFile(DNI_BACK)}
                                        textDescription={textDescription}
                                        textLinkDescription={textLinkDescription}
                                        disabled={isApprovedDataProprietor}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mortgage-request-holder-information__margin">
                            <div className="col-xs-12">
                                <ul className="mortgage-request-holder-information__upload-dni-list">
                                    <li>
                                        <FormattedText
                                            value="mortgageRequestHolderInformation-mortgageRequestHolderInformation_fileMaxSize"
                                            className="mortgage-request-holder-information__upload-dni-label"
                                        />
                                    </li>
                                    <li>
                                        <FormattedText
                                            value="mortgageRequestHolderInformation-fileAllowedTypes"
                                            className="mortgage-request-holder-information__upload-dni-label"
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <MortgageRequestGoToDocCenter />
                            </div>
                        </div>
                    </div>
                </div >
            );
        }

        return content;
    }

    buildPeopleOnChargeContent() {
        const { isHolder, immMortgageRequestState, dataProprietors } = this.props;
        const currentState = immMortgageRequestState.get('estado');
        const isApprovedDataProprietor = contains(mortgageRequestPanelStates.APPROVED_STATES_DATA_PROPRIETOR, currentState);
        const personalData = dataProprietors.get('personalData');
        const hasOperationProcessId = personalData.some(person => person?.operationProcessId);
        let content;

        if (isHolder) {
            content = (
                <div className="col-md-4">
                    <InputSafe
                        label={formatText('mortgageRequestHolderInformation-personsNumber')}
                        name="personsNumber"
                        type="text"
                        value={this.state.personsNumber}
                        disabled={isApprovedDataProprietor || hasOperationProcessId }
                        onBlur={this.handleBlur}
                        onChange={this.handleChange}
                        errorState={!this.state.personsNumberValid.valid}
                        errorMessage={this.state.personsNumberValid.error}
                    />
                </div>
            );
        }

        return content;
    }

    buildConfirmCheckboxContent() {
        const { isHolder, immMortgageRequestState } = this.props;
        const currentState = immMortgageRequestState.get('estado');
        const isApprovedDataProprietor = contains(mortgageRequestPanelStates.APPROVED_STATES_DATA_PROPRIETOR, currentState);
        const addDefaultError = formatText('mortgageRequestHolderInformation-defaultFormError');

        let content;

        if (!isHolder) {
            content = (
                <div className="row mortgage-request-holder-information__margin">
                    <div className="col-md-12">
                        <OKCheckbox
                            idName="confirm"
                            extraClass="mortgage-request-holder-information__checkbox-option"
                            label={formatText('mortgageRequestHolderInformation-checkBoxText')}
                            onChange={this.handleCheckboxChange}
                            value={this.state.confirm}
                            errorState={this.state.confirmValid}
                            errorMessage={addDefaultError}
                            disabled={isApprovedDataProprietor}
                        />
                    </div>
                </div>
            );
        }

        return content;
    }

    buildManagerDocumentation() {
        const { isCompleted } = this.state;
        return isCompleted && (
            <div className="col-xs-12">
                <div className="content-message">
                    <Message />
                </div>
            </div>
        )
    }

    render() {
        const { holderEdit, coHolderEdit, holderInfo, immMortgageRequestState, immFlagBasedFeatures, dataProprietors } = this.props;
        const { isOpenbankClient } = this.state;

        if (holderInfo.get('isFetching') || !holderInfo.get('renderData')) {
            return (
                <div className="row step-item">
                    <LoadingSection />
                </div>
            );
        }

        const currentState = immMortgageRequestState.get('estado');
        const isApprovedDataProprietor = contains(mortgageRequestPanelStates.APPROVED_STATES_DATA_PROPRIETOR, currentState);
        const modal = this.buildModal();
        const dniUploadContent = this.buildDNIUploadContent(isApprovedDataProprietor);
        const peopleOnChargeContent = this.buildPeopleOnChargeContent();
        const confirmCheckboxContent = this.buildConfirmCheckboxContent();
        const saving = holderEdit.get('isFetching') || coHolderEdit.get('isFetching') || holderEdit.get('isUploading');
        const addDefaultError = formatText('mortgageRequestHolderInformation-defaultFormError');
        const saveText = formatText('mortgageRequestHolderInformation-saveButton');
        const typeOfRoadsSelect = typesOfRoadsOptions();
        const { isDisabledButton } = this.state;
        const personalData = dataProprietors.get('personalData');
        const hasOperationProcessId = personalData.some(person => person?.operationProcessId);

        return (
            <ContentBox className="mortgage-request-holder-information__no-padding-bottom">
                {modal}
                <OKBoxTitle
                    value={formatText('mortgageRequestHolderInformation-subtitle')}
                    size="medium"
                    children={formatText('mortgageRequestHolderInformation-subSubtitle', [
                        COMMONS.PRESTAMOS_PHONE
                    ])}
                />
                <div className="row mortgage-request-holder-information__margin">
                    <div className="col-xs-12">
                        <FormattedText
                            value="mortgageRequestHolderInformation-nameFormText"
                            className="mortgage-request-holder-information__field-label"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 mortgage-request-holder-information__field--first">
                        <InputSafe
                            name="name"
                            type="text"
                            value={this.state.name}
                            disabled={isOpenbankClient || hasOperationProcessId }
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            errorState={this.state.nameValid}
                            errorMessage={this.state.nameError}
                        />
                    </div>
                    <div className="col-md-4 mortgage-request-holder-information__field--middle">
                        <InputSafe
                            name="lastname1"
                            type="text"
                            value={this.state.lastname1}
                            disabled={isOpenbankClient || hasOperationProcessId }
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            errorState={this.state.lastname1Valid}
                            errorMessage={this.state.lastname1Error}
                        />
                    </div>
                    <div className="col-md-4 mortgage-request-holder-information__field--last">
                        <InputSafe
                            name="lastname2"
                            type="text"
                            value={this.state.lastname2}
                            disabled={isOpenbankClient || hasOperationProcessId }
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            errorState={this.state.lastname2Valid}
                            errorMessage={this.state.lastname2Error}
                        />
                    </div>
                </div>
                <div className="row mortgage-request-holder-information__margin">
                    <div className="col-md-4">
                        <OKSelect
                            label={formatText(
                                'mortgageRequestHolderInformation-nationalityFormText'
                            )}
                            name="nationality"
                            options={countryOptions()}
                            value={this.state.nationality}
                            clearable={false}
                            searchable
                            onChange={this.handleSelectNacionality}
                            errorState={this.state.nationalityValid}
                            errorMessage={addDefaultError}
                            disabled={hasOperationProcessId }
                        />
                    </div>
                    <div className="col-md-4">
                        <div className="split-fields form__group-inputs">
                            <FormattedText
                                value="mortgageRequestHolderInformation-birthDayForm"
                                className="mortgage-request-holder-information__field-label"
                            />
                            <div className="split__children">
                                <div className="row clear-split">
                                    <div className="col-md-4 mortgage-request-holder-information__first-col mortgage-request-holder-information__first-col--full-msg md-form-group">
                                        <InputSafe
                                            maxLength={2}
                                            name="day"
                                            type="text"
                                            value={this.state.day}
                                            disabled={isOpenbankClient || hasOperationProcessId }
                                            placeholder={formatText(
                                                'mortgageRequestHolderInformation-dayText'
                                            )}
                                            onBlur={this.handleBlur}
                                            onChange={this.handleChange}
                                            errorState={this.state.dayValid}
                                            errorMessage={this.state.dayError}
                                        />
                                    </div>
                                    <div className="col-md-4 mortgage-request-holder-information__middle-col md-form-group">
                                        <InputSafe
                                            maxLength={2}
                                            name="month"
                                            type="text"
                                            value={this.state.month}
                                            disabled={isOpenbankClient || hasOperationProcessId }
                                            placeholder={formatText(
                                                'mortgageRequestHolderInformation-monthText'
                                            )}
                                            onBlur={this.handleBlur}
                                            onChange={this.handleChange}
                                            errorState={this.state.monthValid}
                                            errorMessage={this.state.monthError}
                                        />
                                    </div>
                                    <div className="col-md-4 mortgage-request-holder-information__last-col md-form-group">
                                        <InputSafe
                                            maxLength={4}
                                            name="year"
                                            type="text"
                                            value={this.state.year}
                                            disabled={isOpenbankClient || hasOperationProcessId }
                                            placeholder={formatText(
                                                'mortgageRequestHolderInformation-yearText'
                                            )}
                                            onBlur={this.handleBlur}
                                            onChange={this.handleChange}
                                            errorState={this.state.yearValid}
                                            errorMessage={this.state.yearError}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <OKSelect
                            label={formatText(
                                'mortgageRequestHolderInformation-civilStatusFormText'
                            )}
                            name="civilStatus"
                            options={getCivilStatusOptions()}
                            value={this.state.civilStatus}
                            clearable={false}
                            searchable
                            onChange={this.handleSelectCivilStatus}
                            errorState={this.state.civilStatusValid}
                            errorMessage={addDefaultError}
                            disabled={isApprovedDataProprietor || hasOperationProcessId }
                        />
                    </div>
                </div>
                <div className="row mortgage-request-holder-information__margin">
                    {peopleOnChargeContent}
                    <div className="col-md-4">
                        <div className="form__group-inputs">
                            <FormattedText
                                value="mortgageRequestHolderInformation-idDocFormText"
                                className="mortgage-request-holder-information__field-label"
                            />
                            <div className="row">
                                <div className="col-md-4 mortgage-request-holder-information__first-col">
                                    <OKSelect
                                        name="idDocument"
                                        options={getIdNumberOptions()}
                                        value={this.state.idDocument}
                                        clearable={false}
                                        searchable={false}
                                        disabled
                                        onChange={this.handleSelectIdDocument}
                                    />
                                </div>
                                <div className="col-md-8 mortgage-request-holder-information__final-col">
                                    <InputSafe
                                        name="idDocumentText"
                                        type="text"
                                        value={this.state.idDocumentText}
                                        disabled
                                        onBlur={this.handleBlur}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="split-fields form__group-inputs">
                            <FormattedText
                                value="mortgageRequestHolderInformation-expirationDateFormText"
                                className="mortgage-request-holder-information__field-label"
                            />
                            <div className="split__children">
                                <div className="row clear-split">
                                    <div className="col-md-4 mortgage-request-holder-information__first-col md-form-group">
                                        <InputSafe
                                            maxLength={2}
                                            name="expirationDay"
                                            type="text"
                                            value={this.state.expirationDay}
                                            placeholder={formatText(
                                                'mortgageRequestHolderInformation-dayText'
                                            )}
                                            onBlur={this.handleBlur}
                                            onChange={this.handleChange}
                                            errorState={this.state.expirationDayValid}
                                            errorMessage={this.state.expirationDayError}
                                            disabled={isApprovedDataProprietor || hasOperationProcessId }
                                        />
                                    </div>
                                    <div className="col-md-4 mortgage-request-holder-information__middle-col md-form-group">
                                        <InputSafe
                                            maxLength={2}
                                            name="expirationMonth"
                                            type="text"
                                            value={this.state.expirationMonth}
                                            placeholder={formatText(
                                                'mortgageRequestHolderInformation-monthText'
                                            )}
                                            onBlur={this.handleBlur}
                                            onChange={this.handleChange}
                                            errorState={this.state.expirationMonthValid}
                                            errorMessage={this.state.expirationMonthError}
                                            disabled={isApprovedDataProprietor || hasOperationProcessId }
                                        />
                                    </div>
                                    <div className="col-md-4 mortgage-request-holder-information__last-col md-form-group">
                                        <InputSafe
                                            maxLength={4}
                                            name="expirationYear"
                                            type="text"
                                            value={this.state.expirationYear}
                                            placeholder={formatText(
                                                'mortgageRequestHolderInformation-yearText'
                                            )}
                                            onBlur={this.handleBlur}
                                            onChange={this.handleChange}
                                            errorState={this.state.expirationYearValid}
                                            errorMessage={this.state.expirationYearError}
                                            disabled={isApprovedDataProprietor || hasOperationProcessId }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mortgage-request-holder-information__margin">
                    <div className="col-xs-12">
                        <FormattedText
                            value="mortgageRequestHolderInformation-enterCurrentAddres"
                            className="mortgage-request-holder-information__label"
                        />
                    </div>
                </div>
                <div className="row mortgage-request-holder-information__margin">
                    <div className="col-md-4 ">
                        <OKSelect
                            label={formatText(
                                'mortgageRequestHolderInformation-addressTypeOfRoad'
                            )}
                            name="typeOfRoad"
                            options={typeOfRoadsSelect}
                            value={this.state.typeOfRoad}
                            onChange={this.handleSelectTypeOfRoad}
                            errorState={this.state.typeOfRoadValid}
                            errorMessage={addDefaultError}
                            clearable={false}
                            searchable
                            disabled={isOpenbankClient || hasOperationProcessId }
                        />
                    </div>
                    <div className="col-md-4">
                        <InputSafe
                            maxLength={50}
                            label={formatText(
                                'mortgageRequestHolderInformation-addresNameOfRoad'
                            )}
                            name="nameOfRoad"
                            type="text"
                            value={this.state.nameOfRoad}
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            errorState={this.state.nameOfRoadValid}
                            errorMessage={addDefaultError}
                            disabled={isOpenbankClient || hasOperationProcessId }
                        />
                    </div>
                    <div className="col-md-4">
                        <div className="form__group-inputs">
                            <div className="row">
                                <div className="col-md-4 mortgage-request-holder-information__first-col">
                                    <FormattedText
                                        value="mortgageRequestHolderInformation-addresNumber"
                                        className="mortgage-request-holder-information__field-label"
                                    />
                                    <InputSafe
                                        name="numberOfRoad"
                                        type="text"
                                        value={this.state.numberOfRoad}
                                        onBlur={this.handleBlur}
                                        onChange={this.handleChange}
                                        errorState={this.state.numberOfRoadValid}
                                        errorMessage={addDefaultError}
                                        disabled={isApprovedDataProprietor || isOpenbankClient || hasOperationProcessId}
                                        
                                    />
                                </div>
                                <div className="col-md-8 mortgage-request-holder-information__final-col">
                                    <FormattedText
                                        value="mortgageRequestHolderInformation-addresOther"
                                        className="mortgage-request-holder-information__field-label"
                                    />
                                    <InputSafe
                                        name="placeResidence"
                                        type="text"
                                        value={this.state.placeResidence}
                                        onBlur={this.handleBlur}
                                        onChange={this.handleChange}
                                        errorState={this.state.placeResidenceValid}
                                        errorMessage={addDefaultError}
                                        disabled={isApprovedDataProprietor || isOpenbankClient || hasOperationProcessId}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mortgage-request-holder-information__margin">
                    <div className="col-md-4">
                        <InputSafe
                            maxLength={5}
                            label={formatText(
                                'mortgageRequestHolderInformation-addresPostalCode'
                            )}
                            name="postalCode"
                            type="text"
                            value={this.state.postalCode}
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            errorState={this.state.postalCodeValid}
                            errorMessage={addDefaultError}
                            disabled={isOpenbankClient || hasOperationProcessId }
                        />
                    </div>
                    <div className="col-md-4">
                        <OKSelect
                            label={formatText(
                                'mortgageRequestHolderInformation-provinceFormText'
                            )}
                            name="province"
                            options={this.provinces}
                            value={this.state.province.value}
                            clearable={false}
                            searchable
                            onChange={this.handleSelectProvince}
                            errorState={this.state.provinceValid}
                            errorMessage={addDefaultError}
                            disabled={isOpenbankClient || hasOperationProcessId }
                        />
                    </div>
                    <div className="col-md-4">
                        <OKSelect
                            label={formatText(
                                'mortgageRequestHolderInformation-locationFormText'
                            )}
                            name="location"
                            options={this.locations}
                            value={this.state.location.value}
                            clearable={false}
                            searchable
                            onChange={this.handleSelectLocation}
                            errorState={this.state.locationValid}
                            errorMessage={addDefaultError}
                            disabled={isOpenbankClient || hasOperationProcessId }
                        />
                    </div>
                </div>
                {confirmCheckboxContent}
                {!(immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER)) ? dniUploadContent : null}
                <div className="row mortgage-request-holder-information__margin">
                    <div className="col-xs-12">
                        <div className="mortgage-request-holder-information__footer-buttons">
                            <a href="#" className="ok-link" onClick={this.handleCancelAddCoHolder}>
                                <FormattedText value="mortgageRequestHolderInformation-returnLink" />
                            </a>
                            <div className="pull-right">
                            {   
                                !hasOperationProcessId && (
                                <OKButton
                                    onClick={this.handleSave}
                                    modifier="primary"
                                    loading={saving}
                                    disabled={isDisabledButton || isApprovedDataProprietor}
                                >
                                    {saveText}
                                </OKButton>
                                )
                            }
                            </div>
                        </div>
                    </div>
                    {
                        this.buildManagerDocumentation()
                    }
                </div>
            </ContentBox >
        );
    }
}

MortgageRequestHolderInformation.propTypes = {
    holderInfo: PropTypes.object,
    holderEdit: PropTypes.object,
    coHolderEdit: PropTypes.object,
    isHolder: PropTypes.bool,
    holderId: PropTypes.string,
    orderNm: PropTypes.number,
    requestHolder: PropTypes.func,
    handleEditHolder: PropTypes.func,
    handleEditCoHolder: PropTypes.func,
    setField: PropTypes.func,
    history: PropTypes.object.isRequired,
    immMortgageRequestState: PropTypes.object,
    resetPersonalDataState: PropTypes.func,
    resetCoHolderDataState: PropTypes.func,
    isClientWithoutAccounts: PropTypes.bool,
    addFile: PropTypes.func,
    uploadFiles: PropTypes.func,
    requestProvincesData: PropTypes.func,
    requestLocationData: PropTypes.func,
    immMortgageRequestLocationData: PropTypes.object,
    immSummaryDocumentation: PropTypes.object,
    requestSummaryDocumentation: PropTypes.func,
    requestDocument: PropTypes.func,
    immFlagBasedFeatures: PropTypes.object,
    holdersDataValidation: PropTypes.object,
    immGlobalPosition: PropTypes.object,
};

module.exports.MortgageRequestHolderInformation = connect(
    state => ({
        holderInfo: state.mortgageRequestHolder,
        holderEdit: state.mortgageRequestHolderEdit,
        coHolderEdit: state.mortgageRequestCoHolderEdit,
        immMortgageRequestState: state.mortgageRequestState,
        immMortgageRequestLocationData: state.mortgageRequestLocationData,
        immSummaryDocumentation: state.mortgageRequestSummaryDocumentation,
        immFlagBasedFeatures: state.flagBasedFeatures,
        holdersDataValidation: state.mortgageHoldersDataValidation,
        immGlobalPosition:state.globalPosition,
        dataProprietors: state.mortgageRequestDataProprietor,
        }),
    {
        requestHolder: getHolderActions.requestHolder,
        handleEditHolder: getHolderActions.editHolder,
        handleEditCoHolder: getHolderActions.editCoHolder,
        resetPersonalDataState: getHolderActions.reset,
        resetCoHolderDataState: getHolderActions.resetCoHolder,
        setField: getHolderActions.setField,
        addFile: getHolderActions.addFile,
        uploadFiles: getHolderActions.uploadFiles,
        requestProvincesData: getLocationData.requestProvincesData,
        requestLocationData: getLocationData.requestLocationData,
        requestSummaryDocumentation: dataProprietorActions.requestSummaryDocumentation,
        requestDocument: documentActions.getDocument,
        requestDataProprietor: dataProprietorActions.requestDataProprietor,
    }
)(withRouter(MortgageRequestHolderInformation));
